import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

interface Props {
  description?: string;
  lang?: string;
  title: string;
  keywords?: string;
  ogUrl?: string;
  ogImage?: string;
  meta?: object[];
  canonical?: string;
}

export const Seo = ({
  description = '',
  lang = 'ja',
  title,
  meta = [],
  keywords = '',
  ogUrl,
  ogImage,
  canonical,
}: Props) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `,
  );
  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  const siteUrl = site.siteMetadata.siteUrl;
  const defaultOgImg = `${siteUrl}/images/ogp.jpg`;

  return (
    <>
      <html lang={lang} />
      <title>{title + ' | ' + defaultTitle}</title>
      <link rel="canonical" href={canonical ? siteUrl + canonical : siteUrl} />
      <meta name="description" content={metaDescription} />
      <meta
        property="og:title"
        content={`${title} | 患者とつながる クラウド歯科業務支援システム Dentis（デンティス）`}
      />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={ogUrl || siteUrl} />
      <meta property="og:image" content={ogImage || defaultOgImg} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="©2022 MEDLEY, INC." />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={title} />
    </>
  );
};

export default Seo;
